import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import account from './modules/account'

const appModulesObj = { account: account }

Vue.use(Vuex)

export default new Vuex.Store({
  modules: appModulesObj,
  state: {
    currentMenu: '/index',
    userInfo: {},
    userId: '',
    im: false,
    requestCancels: [], // 当前路由的所有Axios请求取消函数
    userType: 0,
    globalConfig: {}, // 全局配置
  },
  mutations: {
    setGlobalConfig(state, config) {
      state.globalConfig = config
    },
    SET_MENU (state, value) {
      state.currentMenu = value
    },
    SET_IM (state, value) {
      state.im = value
      console.log('im', state.im)
      sessionStorage.setItem('im', value)
    },
    SET_USERINFO (state, value) {
      state.userInfo = value
      state.userId = value.userId
      sessionStorage.setItem('userId', value.userId)
    },
    SET_USERTYPE (state, value) {
      state.userType = value
    }
  },
  actions: {

  },
  getters
})
